import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import {
  FaBell,
  FaExclamationTriangle,
  FaFileInvoiceDollar,
  FaPaperPlane,
} from "react-icons/fa"
import { withTranslation } from "react-i18next"
import Configs from "../../../config"
import Swal from "sweetalert2"

// Notification data
const notificationsData = []

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false)

  const sendNotification = notification => {
    Swal.fire({
      icon: "success",
      title: "Notification Sent Successfully",
    })
  }

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="dropdown d-inline-block"
      tag="li"
    >
      <DropdownToggle
        className="btn header-item noti-icon position-relative"
        tag="button"
        id="page-header-notifications-dropdown"
      >
        <i className="bx bx-bell bx-tada text-dark" />
        <span className="badge bg-danger rounded-pill">
          {notificationsData.length}
        </span>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
        <div className="p-3">
          <Row className="align-items-center">
            <Col>
              <h6 className="m-0">{props.t("Notifications")}</h6>
            </Col>
            <div className="col-auto">
              <a href={`${Configs.appurl}notifications`} className="small">
                View All
              </a>
            </div>
          </Row>
        </div>

        <SimpleBar style={{ height: "230px" }}>
          {notificationsData.map(notification => (
            <div
              key={notification.id}
              className="text-reset notification-item d-flex align-items-start justify-content-between p-2"
            >
              <div className="d-flex align-items-start">
                <div className="avatar-xs me-3">
                  <span className="avatar-title bg-light rounded-circle fs-5">
                    {notification.icon}
                  </span>
                </div>
                <div>
                  <h6 className="mt-0 mb-1">{notification.title}</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">{notification.description}</p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />{" "}
                      {notification.date}
                    </p>
                  </div>
                </div>
              </div>

              {/* Send button for missing logs or pending tasks */}
              {(notification.type === "missing" ||
                notification.type === "pending") && (
                <button
                  className="btn btn-sm btn-primary ms-2"
                  onClick={() => sendNotification(notification)}
                >
                  <FaPaperPlane />
                </button>
              )}
            </div>
          ))}
        </SimpleBar>
      </DropdownMenu>
    </Dropdown>
  )
}

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(NotificationDropdown)
